import { Product } from '@app/api';

export const isProductDisplayable = (p: Product, category?: string) => {
  if (category && p.category !== category) {
    return false;
  }

  if (!category && !p.importantFeature) {
    return false;
  }

  return !!p.title && p.title !== '-';
};
